module.exports = __webpack_public_path__ + "static/media/info.c35436c7.svg";